//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'Table',
  props: {
    selectAll: {
      type: Boolean,
      default: true
    },
    tableData: {
      type: Array,
      default: {}
    },
    total: {
      type: Number,
      default: 0
    },
    notEmployees: {
      type: String,
      default: ''
    },
    showText: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      where: {
        page: 1,
        limit: 15
      },
      multipleSelectList: [],
      tabTypes: localStorage.getItem('tabTypes')
    };
  },
  computed: {
    addTime: function addTime() {
      if (this.notEmployees == '未入职') {
        return '面试时间';
      } else if (this.notEmployees == '离职') {
        return '离职时间';
      } else {
        return '入职时间';
      }
    },
    propTime: function propTime() {
      if (this.notEmployees == '未入职') {
        return 'interview_date';
      } else if (this.notEmployees == '离职') {
        return 'quit_time';
      } else {
        return 'work_time';
      }
    }
  },
  methods: {
    getSex: function getSex(val) {
      var sexData = {
        0: '未知',
        1: '男',
        2: '女',
        3: '其他'
      };
      return sexData[val];
    },
    getEducation: function getEducation(val) {
      var educationData = {
        2: '高中及以下',
        4: '专科',
        5: '本科',
        6: '研究生'
      };
      return educationData[val] || '--';
    },
    getIsPart: function getIsPart(val) {
      var partData = {
        0: '全职',
        1: '兼职',
        2: '实习',
        3: '劳务派遣',
        4: '退休返聘',
        5: '劳务外包',
        6: '其他'
      };
      return partData[val];
    },
    handleSizeChange: function handleSizeChange(val) {
      this.where.limit = val;
      this.$emit('limitFn', val);
    },
    pageChange: function pageChange(page) {
      this.where.page = page;
      this.$emit('pageFn', page);
    },
    // 勾选表格
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelectList = val;
      this.$emit('multipleSelection', val);
    }
  }
};